var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"trustscore-progress"},[_c('div',{ref:"dot",staticClass:"trustscore-progress__dot"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }